<template>
  <b-modal v-model="modal" centered no-close-on-esc no-close-on-backdrop>
    <h5 class="modal-title" slot="modal-header">
      Progresso da operação
    </h5>

    <b-progress :value="progresso" variant="success" striped animated></b-progress>
    <div class="w-100" slot="modal-footer">
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "progressoModal",
  model: {
    prop: "mostrarModal",
    event: "change"
  },
  props: {
    progresso: {
      type: Number,
      required: true
    },
    mostrarModal: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      modal: this.mostrarModal,
      valor: this.progresso
    };
  },
  watch: {
    mostrarModal(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      this.modal = newVal;
      this.valor = this.progresso;
    }
  },
  methods: {
    fecharModal() {
      this.modal = false;
      this.valor = 0;
      this.$emit("change", false);
    }
  }
};
</script>
<style lang="scss">
</style>
